import { render } from "./PokemonGallery.vue?vue&type=template&id=3c87d640&scoped=true"
import script from "./PokemonGallery.vue?vue&type=script&lang=js"
export * from "./PokemonGallery.vue?vue&type=script&lang=js"

import "./PokemonGallery.vue?vue&type=style&index=0&id=3c87d640&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Eric\\Desktop\\WEB\\apichu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c87d640"]])

export default __exports__